<template>
  <div class="page">
    <!-- 头部 -->
    <Header title="我的收藏" :leftHandler="onClickLeft" />
    <div class="favorite-list" v-for="(item,index) in favoriteList" :key="index" @click="goToDetail(item)">
      <van-swipe-cell>
        <OrderDetailBox :detailItem="item" height="2rem" isFavorite bgColor="#fff"></OrderDetailBox>
        <template #right>
          <van-button square text="删除" type="danger" class="delete-button" @click="deleteItem(item.itemId)" />
        </template>
      </van-swipe-cell>
    </div>
    <p class="text-center m-y-2" v-if="!favoriteList.length">没有更多了</p>
  </div>
</template>

<script>
import Header from '@/components/header'
import centerApi from '@/api/center'
import OrderDetailBox from '@/components/order-detail-box.vue'
import sortApi from '@/api/sort'
export default {
  components: {
    Header,
    OrderDetailBox
  },
  data () {
    return {
      favoriteList: []
    }
  },
  created () {
    this.init()
  },
  computed: {
  },
  methods: {
    init () {
      this.getFavoriteList()
    },
    // 获取收藏列表
    getFavoriteList () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      centerApi.getFavoriteList().then(res => {
        if (res.data.resultCode === '0') {
          this.favoriteList = res.data.resultData.favoriteList
          this.$toast.clear()
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 左滑删除
    deleteItem (itemId) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否删除所选择的礼品'
      }).then(() => {
        const data = [{
          itemId: itemId
        }]
        sortApi.removeFavorite(data).then(res => {
          if (res.data.resultCode === '0') {
            this.getFavoriteList()
          }
        })
      }).catch(() => { })
    },
    onClickLeft () {
      this.$router.push({
        name: 'center'
      })
    },
    // 礼品详情
    goToDetail (item) {
      if (item.itemCategoryCode === '501') {
        this.$router.push({
          name: 'knowledge-goods',
          query: {
            itemId: item.itemId
          }
        })
      } else {
        this.$router.push({
          name: 'goods-detail',
          query: {
            itemId: item.itemId
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.favorite-list {
  margin-bottom: 0.2rem;

  .delete-button {
    height: 100%;
  }
}
.m-y-2{
  margin: 0.5rem 0rem;
}
</style>
